<template>
  <!-- When user clicks back, we don't want to validate any fields. However, on blur, some fields will validate. So we prevent/stop @mousedown to prevent section navigation from triggering blurs -->
  <div :class="computedClass" class="rf-section-nav" @click.prevent.stop="onClick" @keydown.enter="onClick" @mousedown.prevent.stop v-if="parentSection.paginated || (!parentSection.isComplete || parentSection.isActive)" :tabindex="this.disabled ? -1 : 0">
    <slot></slot>
  </div>
</template>

<script>
import getParent from '../util/getParent'
import parentForm from '../mixins/parentForm'

export default {
  name: 'RfSectionNav',
  mixins: [parentForm],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    next: {
      type: Boolean,
      default: true
    },
    prev: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.componentType = 'rf-section-nav'
  },
  computed: {
    computedClass () {
      return { 'is-disabled': this.disabled }
    },
    computedDirection () {
      return !this.prev ? 'next' : 'prev'
    },
    parentSection () {
      return getParent(this, 'rf-section')
    }
  },
  methods: {
    onClick (e) {
      if (!this.disabled) {
        this.parentForm.$emit('section:nav-' + this.computedDirection, this.parentSection, e)
      }
    }
  }
}
</script>

<style>
  .rf-section-nav {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// RfSectionNav.vue?48f77c05